import React from 'react';
import P from 'prop-types';
import { graphql, compose } from 'react-apollo';

import logo from 'assets/images/becollective-logo.svg';
import Button from 'components/Button/';
import Icon from 'components/Icon/';
import { SIDEBAR_QUERY } from 'gql/queries';
import ensureLoggedIn from 'utils/ensureLoggedIn';
import displayLoading from 'utils/displayLoading';
import config from 'config';
import { ThemeContext } from 'components/App/';

import './Sidebar.scss';

const Sidebar = ({ data }) => {
  const { user, group } = data.store;
  const { firstName, lastName } = user;

  return (
    <ThemeContext.Consumer>
      {({ hidePoweredByText }) => (
        <div className="Sidebar">
          <h2 className="Sidebar-heading">
            Hi, {firstName} {lastName}
          </h2>
          <div className="Sidebar-main">
            {group && group.id && (
              <Button
                className="ml-0"
                color="transparent"
                underlineText
                leftAlignText
                onClick={() => {
                  window.open(`${config.WEB_URL}/manage/groups/${group.id}/opportunities?ignoreRegionGuess=true`);
                }}
              >
                <span>Manage opportunities</span>
                <Icon name="launchExternal" size={Icon.SIZE.xxs} className="ml-2" />
              </Button>
            )}
            {group && group.id && (
              <Button
                className="ml-0"
                color="transparent"
                underlineText
                leftAlignText
                onClick={() => {
                  window.open(`${config.WEB_URL}/manage/groups/${group.id}/volunteers?ignoreRegionGuess=true`);
                }}
              >
                <span>Manage volunteers</span>
                <Icon name="launchExternal" size={Icon.SIZE.xxs} className="ml-2" />
              </Button>
            )}
            {group && group.id && (
              <Button
                className="ml-0"
                color="transparent"
                underlineText
                leftAlignText
                onClick={() => {
                  window.open(`${config.WEB_URL}/manage/groups/${group.id}/schedule?ignoreRegionGuess=true`);
                }}
              >
                <span>Manage schedule</span>
                <Icon name="launchExternal" size={Icon.SIZE.xxs} className="ml-2" />
              </Button>
            )}
            {group && group.id && (
              <Button
                className="ml-0"
                color="transparent"
                underlineText
                leftAlignText
                onClick={() => {
                  window.open(`${config.WEB_URL}/manage/groups/${group.id}/settings?ignoreRegionGuess=true`);
                }}
              >
                <span>Group settings</span>
                <Icon name="launchExternal" size={Icon.SIZE.xxs} className="ml-2" />
              </Button>
            )}
            {group && group.id && (
              <Button
                className="ml-0"
                color="transparent"
                underlineText
                leftAlignText
                onClick={() => {
                  window.open(`${config.WEB_URL}/manage/groups/${group.id}/summary?ignoreRegionGuess=true`);
                }}
              >
                <span>Manage my Group</span>
                <Icon name="launchExternal" size={Icon.SIZE.xxs} className="ml-2" />
              </Button>
            )}
            <Button
              className="ml-0"
              color="transparent"
              underlineText
              leftAlignText
              onClick={() => {
                window.open(`${config.WEB_URL}/dashboard/settings?ignoreRegionGuess=true`);
              }}
            >
              <span>Account settings</span>
              <Icon name="launchExternal" size={Icon.SIZE.xxs} className="ml-2" />
            </Button>
            <Button
              className="ml-0"
              color="transparent"
              underlineText
              leftAlignText
              onClick={() => {
                localStorage.setItem('accessToken', '');
                window.location.reload();
              }}
            >
              <span>Log out</span>
            </Button>
          </div>
          {!hidePoweredByText && (
            <div className="Sidebar-footer">
              Powered by <img className="Sidebar-logo" src={logo} alt="Be Collective" />
            </div>
          )}
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

Sidebar.propTypes = {
  data: P.shape({
    store: P.shape({
      user: P.shape({
        firstName: P.string.isRequired,
        lastName: P.string.isRequired,
      }).isRequired,
      group: P.shape({
        id: P.string.isRequired,
      }),
    }),
  }),
};

export default compose(
  graphql(SIDEBAR_QUERY, {
    options: ({ groupId }) => ({
      variables: {
        groupId: groupId || '',
      },
      fetchPolicy: 'network-only',
    }),
  }),
  ensureLoggedIn,
  displayLoading(),
)(Sidebar);
